module.exports = __webpack_public_path__ + "static/media/termsAndConditions.941bde80.md";